import { createFileRoute } from '@tanstack/react-router'
import { LayoutCard } from '@/components/layouts/LayoutCard'
import { TermsContent } from '@/components/common/TermsContent'

export const Route = createFileRoute('/terms')({
  component: TermsPage,
})

function TermsPage() {
  return (
    <LayoutCard title="Terms of Service">
      <TermsContent />
    </LayoutCard>
  )
}
